export const ZONES = [
    {
        "id": "dol",
        "label": "Dol & Baie du Mont-Saint-Michel",
        "intro": "Entre les polders de la baie du Mont-Saint-Michel et le pays de Dol, les locations saisonnières, chambres d'hôtes et résidences secondaires accueillent des visiteurs toute l'année : les punaises de lit voyagent avec les valises et s'installent vite dans les literies."
    },
    {
        "id": "saint-malo",
        "label": "Saint-Malo & Cancale",
        "intro": "Sur le littoral malouin, entre la cité corsaire, les hôtels et les nombreux meublés touristiques, les infestations de punaises de lit sont fréquentes, en saison comme hors saison."
    },
    {
        "id": "dinard",
        "label": "Dinard & vallée de la Rance",
        "intro": "De Dinard à la vallée de la Rance, les villas, résidences secondaires et hôtels de la côte d'Émeraude changent souvent d'occupants : un contexte idéal pour l'arrivée des punaises de lit."
    },
    {
        "id": "dinan",
        "label": "Dinan & son pays",
        "intro": "Dans le pays de Dinan, entre centre médiéval, commerces et gîtes ruraux, les punaises de lit se propagent facilement d'un logement à l'autre, en ville comme à la campagne."
    },
    {
        "id": "emeraude",
        "label": "Côte d'Émeraude & Saint-Cast",
        "intro": "Sur la côte d'Émeraude, de Saint-Jacut-de-la-Mer à Erquy, la forte saison estivale, les campings et les locations de vacances multiplient les risques d'infestation de punaises de lit."
    },
    {
        "id": "rennes",
        "label": "Axe Mont-Dol - Rennes",
        "intro": "Sur l'axe Mont-Dol - Rennes, la forte mobilité des actifs et des étudiants, les colocations et les résidences locatives favorisent la circulation des punaises de lit dans toute la métropole."
    },
    {
        "id": "lamballe",
        "label": "Axe Dinan - Lamballe - Saint-Brieuc",
        "intro": "Sur l'axe Dinan - Lamballe - Saint-Brieuc, les communes rurales et périurbaines du bassin briochin ne sont pas épargnées : les punaises de lit s'installent aussi bien dans les bourgs que dans les zones pavillonnaires."
    }
];

export const CITIES = [
    {
        "slug": "mont-dol",
        "name": "Mont-Dol",
        "zone": "dol",
        "dept": "Ille-et-Vilaine (35)",
        "dist": "2 km"
    },
    {
        "slug": "dol-de-bretagne",
        "local": "À Dol-de-Bretagne, la gare TGV sur la ligne Paris-Saint-Malo fait passer des milliers de voyageurs chaque semaine, et le centre ancien autour de la cathédrale Saint-Samson concentre des logements chargés d'histoire. Les punaises de lit y voyagent dans les bagages et s'installent dans les literies des maisons de ville comme dans les gîtes de la baie. Basés au Mont-Dol, à quelques minutes, nous sommes littéralement vos voisins : diagnostic et traitement dans la journée, 7j/7.",
        "name": "Dol-de-Bretagne",
        "zone": "dol",
        "dept": "Ille-et-Vilaine (35)",
        "dist": "3 km"
    },
    {
        "slug": "le-vivier-sur-mer",
        "name": "Le Vivier-sur-Mer",
        "zone": "dol",
        "dept": "Ille-et-Vilaine (35)",
        "dist": "4 km"
    },
    {
        "slug": "hirel",
        "name": "Hirel",
        "zone": "dol",
        "dept": "Ille-et-Vilaine (35)",
        "dist": "5 km"
    },
    {
        "slug": "cherrueix",
        "name": "Cherrueix",
        "zone": "dol",
        "dept": "Ille-et-Vilaine (35)",
        "dist": "6 km"
    },
    {
        "slug": "baguer-pican",
        "name": "Baguer-Pican",
        "zone": "dol",
        "dept": "Ille-et-Vilaine (35)",
        "dist": "7 km"
    },
    {
        "slug": "baguer-morvan",
        "name": "Baguer-Morvan",
        "zone": "dol",
        "dept": "Ille-et-Vilaine (35)",
        "dist": "8 km"
    },
    {
        "slug": "roz-landrieux",
        "name": "Roz-Landrieux",
        "zone": "dol",
        "dept": "Ille-et-Vilaine (35)",
        "dist": "9 km"
    },
    {
        "slug": "la-fresnais",
        "name": "La Fresnais",
        "zone": "dol",
        "dept": "Ille-et-Vilaine (35)",
        "dist": "10 km"
    },
    {
        "slug": "lillemer",
        "name": "Lillemer",
        "zone": "dol",
        "dept": "Ille-et-Vilaine (35)",
        "dist": "11 km"
    },
    {
        "slug": "saint-broladre",
        "name": "Saint-Broladre",
        "zone": "dol",
        "dept": "Ille-et-Vilaine (35)",
        "dist": "12 km"
    },
    {
        "slug": "saint-marcan",
        "name": "Saint-Marcan",
        "zone": "dol",
        "dept": "Ille-et-Vilaine (35)",
        "dist": "13 km"
    },
    {
        "slug": "roz-sur-couesnon",
        "name": "Roz-sur-Couesnon",
        "zone": "dol",
        "dept": "Ille-et-Vilaine (35)",
        "dist": "14 km"
    },
    {
        "slug": "saint-georges-de-grehaigne",
        "name": "Saint-Georges-de-Gréhaigne",
        "zone": "dol",
        "dept": "Ille-et-Vilaine (35)",
        "dist": "15 km"
    },
    {
        "slug": "epiniac",
        "name": "Épiniac",
        "zone": "dol",
        "dept": "Ille-et-Vilaine (35)",
        "dist": "2 km"
    },
    {
        "slug": "la-boussac",
        "name": "La Boussac",
        "zone": "dol",
        "dept": "Ille-et-Vilaine (35)",
        "dist": "3 km"
    },
    {
        "slug": "broualan",
        "name": "Broualan",
        "zone": "dol",
        "dept": "Ille-et-Vilaine (35)",
        "dist": "4 km"
    },
    {
        "slug": "trans-la-foret",
        "name": "Trans-la-Forêt",
        "zone": "dol",
        "dept": "Ille-et-Vilaine (35)",
        "dist": "5 km"
    },
    {
        "slug": "pleine-fougeres",
        "name": "Pleine-Fougères",
        "zone": "dol",
        "dept": "Ille-et-Vilaine (35)",
        "dist": "6 km"
    },
    {
        "slug": "sains",
        "name": "Sains",
        "zone": "dol",
        "dept": "Ille-et-Vilaine (35)",
        "dist": "7 km"
    },
    {
        "slug": "saint-guinoux",
        "name": "Saint-Guinoux",
        "zone": "dol",
        "dept": "Ille-et-Vilaine (35)",
        "dist": "8 km"
    },
    {
        "slug": "miniac-morvan",
        "name": "Miniac-Morvan",
        "zone": "dol",
        "dept": "Ille-et-Vilaine (35)",
        "dist": "9 km"
    },
    {
        "slug": "plerguer",
        "name": "Plerguer",
        "zone": "dol",
        "dept": "Ille-et-Vilaine (35)",
        "dist": "10 km"
    },
    {
        "slug": "saint-benoit-des-ondes",
        "name": "Saint-Benoît-des-Ondes",
        "zone": "saint-malo",
        "dept": "Ille-et-Vilaine (35)",
        "dist": "16 km"
    },
    {
        "slug": "la-gouesniere",
        "name": "La Gouesnière",
        "zone": "saint-malo",
        "dept": "Ille-et-Vilaine (35)",
        "dist": "17 km"
    },
    {
        "slug": "saint-meloir-des-ondes",
        "name": "Saint-Méloir-des-Ondes",
        "zone": "saint-malo",
        "dept": "Ille-et-Vilaine (35)",
        "dist": "18 km"
    },
    {
        "slug": "cancale",
        "local": "À Cancale, entre le port de la Houle, ses restaurants d'huîtres et les hôtels de la côte, l'activité touristique bat son plein dès les beaux jours. Les punaises de lit profitent de ce va-et-vient pour coloniser chambres d'hôtes, gîtes et logements du bourg. Nous intervenons rapidement sur Cancale et la côte d'Émeraude, avec un traitement discret qui ne perturbe ni vos clients ni votre activité, même en pleine saison.",
        "name": "Cancale",
        "zone": "saint-malo",
        "dept": "Ille-et-Vilaine (35)",
        "dist": "19 km"
    },
    {
        "slug": "saint-coulomb",
        "name": "Saint-Coulomb",
        "zone": "saint-malo",
        "dept": "Ille-et-Vilaine (35)",
        "dist": "20 km"
    },
    {
        "slug": "saint-malo",
        "local": "À Saint-Malo, la plupart des infestations arrivent par les valises : entre les appartements d'intra-muros loués en saison, les hôtels de la digue et les résidences de Saint-Servan ou de Paramé, la rotation des voyageurs est constante. Les punaises de lit s'installent dans les sommiers et les plinthes des belles bâtisses malouines sans distinction de standing. Nous intervenons dans toute la cité corsaire, y compris en accès délicat dans la vieille ville, avec un diagnostic sous 2h et un traitement adapté au bâti ancien.",
        "name": "Saint-Malo",
        "zone": "saint-malo",
        "dept": "Ille-et-Vilaine (35)",
        "dist": "21 km"
    },
    {
        "slug": "saint-jouan-des-guerets",
        "local": "À Saint-Jouan-des-Guérets, la zone hôtelière en périphérie de Saint-Malo accueille chaque nuit des centaines de professionnels et de touristes. Une chambre infestée peut coûter cher en nuitées perdues et en avis négatifs : nous intervenons en discrétion totale avec un véhicule banalisé, et le traitement vapeur permet de relouer la chambre le jour même. Les pavillons du bourg bénéficient du même soin.",
        "name": "Saint-Jouan-des-Guérets",
        "zone": "saint-malo",
        "dept": "Ille-et-Vilaine (35)",
        "dist": "22 km"
    },
    {
        "slug": "saint-pere-marc-en-poulet",
        "name": "Saint-Père-Marc-en-Poulet",
        "zone": "saint-malo",
        "dept": "Ille-et-Vilaine (35)",
        "dist": "23 km"
    },
    {
        "slug": "saint-suliac",
        "name": "Saint-Suliac",
        "zone": "saint-malo",
        "dept": "Ille-et-Vilaine (35)",
        "dist": "24 km"
    },
    {
        "slug": "la-ville-es-nonais",
        "name": "La Ville-ès-Nonais",
        "zone": "saint-malo",
        "dept": "Ille-et-Vilaine (35)",
        "dist": "25 km"
    },
    {
        "slug": "chateauneuf-d-ille-et-vilaine",
        "name": "Châteauneuf-d'Ille-et-Vilaine",
        "zone": "saint-malo",
        "dept": "Ille-et-Vilaine (35)",
        "dist": "26 km"
    },
    {
        "slug": "le-tronchet",
        "name": "Le Tronchet",
        "zone": "saint-malo",
        "dept": "Ille-et-Vilaine (35)",
        "dist": "27 km"
    },
    {
        "slug": "bonnemain",
        "name": "Bonnemain",
        "zone": "saint-malo",
        "dept": "Ille-et-Vilaine (35)",
        "dist": "28 km"
    },
    {
        "slug": "meillac",
        "name": "Meillac",
        "zone": "saint-malo",
        "dept": "Ille-et-Vilaine (35)",
        "dist": "29 km"
    },
    {
        "slug": "combourg",
        "local": "À Combourg, la petite cité de caractère et son château de Chateaubriand attirent gîtes ruraux, chambres d'hôtes et visiteurs toute l'année. Dans ce tissu de maisons anciennes au cœur de la campagne romantique, les punaises de lit arrivent le plus souvent par la location saisonnière. Nous traitons les logements comme les hébergements touristiques de Combourg, en toute discrétion et avec un rapport écrit à l'appui.",
        "name": "Combourg",
        "zone": "saint-malo",
        "dept": "Ille-et-Vilaine (35)",
        "dist": "16 km"
    },
    {
        "slug": "tremeheuc",
        "name": "Tréméheuc",
        "zone": "saint-malo",
        "dept": "Ille-et-Vilaine (35)",
        "dist": "17 km"
    },
    {
        "slug": "cuguen",
        "name": "Cuguen",
        "zone": "saint-malo",
        "dept": "Ille-et-Vilaine (35)",
        "dist": "18 km"
    },
    {
        "slug": "lourmais",
        "name": "Lourmais",
        "zone": "saint-malo",
        "dept": "Ille-et-Vilaine (35)",
        "dist": "19 km"
    },
    {
        "slug": "lanrigan",
        "name": "Lanrigan",
        "zone": "saint-malo",
        "dept": "Ille-et-Vilaine (35)",
        "dist": "20 km"
    },
    {
        "slug": "dinard",
        "local": "À Dinard, les villas de la Belle Époque qui surplombent la plage de l'Écluse et les hôtels de la promenade du Clair de Lune accueillent une clientèle de passage toute l'année. Valises, literies d'appoint et locations saisonnières sont les vecteurs classiques des punaises de lit dans la station. Notre intervention discrète préserve la réputation de votre villa ou de votre établissement, et la vapeur sèche 180°C permet de remettre les chambres en location sans délai.",
        "name": "Dinard",
        "zone": "dinard",
        "dept": "Ille-et-Vilaine (35)",
        "dist": "24 km"
    },
    {
        "slug": "la-richardais",
        "name": "La Richardais",
        "zone": "dinard",
        "dept": "Ille-et-Vilaine (35)",
        "dist": "25 km"
    },
    {
        "slug": "pleurtuit",
        "local": "À Pleurtuit, la proximité de l'aéroport Dinard-Bretagne et des hébergements de la vallée de la Rance génère un flux constant de voyageurs. Les punaises de lit profitent des valises pour s'installer dans les gîtes, chambres d'hôtes et maisons du secteur. Notre technicien intervient rapidement sur Pleurtuit et les communes de la Rance, avec un diagnostic précis avant tout traitement.",
        "name": "Pleurtuit",
        "zone": "dinard",
        "dept": "Ille-et-Vilaine (35)",
        "dist": "26 km"
    },
    {
        "slug": "le-minihic-sur-rance",
        "name": "Le Minihic-sur-Rance",
        "zone": "dinard",
        "dept": "Ille-et-Vilaine (35)",
        "dist": "27 km"
    },
    {
        "slug": "saint-lunaire",
        "local": "À Saint-Lunaire, les grandes villas familiales face à la mer et les locations d'été se remplissent et se vident au rythme des saisons. Chaque changement d'occupants est une occasion pour les punaises de lit de s'installer dans la literie. Nous intervenons sur la station avant, pendant et après la saison, avec un traitement vapeur sans produit chimique qui laisse les lieux habitables immédiatement, idéal entre deux locataires.",
        "name": "Saint-Lunaire",
        "zone": "dinard",
        "dept": "Ille-et-Vilaine (35)",
        "dist": "28 km"
    },
    {
        "slug": "saint-briac-sur-mer",
        "local": "À Saint-Briac-sur-Mer, village balnéaire prisé aux maisons de caractère, les résidences secondaires restent parfois fermées des semaines entre deux occupations : une infestation de punaises de lit peut alors passer inaperçue et s'étendre. Nous réalisons la recherche complète du logement, traitons chaque pièce touchée et vous remettons un compte rendu clair avant la remise en location ou votre retour sur place.",
        "name": "Saint-Briac-sur-Mer",
        "zone": "dinard",
        "dept": "Ille-et-Vilaine (35)",
        "dist": "29 km"
    },
    {
        "slug": "lancieux",
        "local": "À Lancieux, les campings du bord de mer, les villages de vacances et les locations estivales concentrent une forte rotation de vacanciers, principale source d'introduction des punaises de lit. Nous intervenons sur les mobil-homes, les chalets comme les maisons du bourg, avec des créneaux larges de 8h à 22h pour ne jamais bloquer une arrivée de vacanciers.",
        "name": "Lancieux",
        "zone": "dinard",
        "dept": "Ille-et-Vilaine (35)",
        "dist": "30 km"
    },
    {
        "slug": "beaussais-sur-mer",
        "name": "Beaussais-sur-Mer",
        "zone": "dinard",
        "dept": "Ille-et-Vilaine (35)",
        "dist": "31 km"
    },
    {
        "slug": "tremereuc",
        "name": "Tréméreuc",
        "zone": "dinard",
        "dept": "Ille-et-Vilaine (35)",
        "dist": "32 km"
    },
    {
        "slug": "langrolay-sur-rance",
        "name": "Langrolay-sur-Rance",
        "zone": "dinard",
        "dept": "Ille-et-Vilaine (35)",
        "dist": "33 km"
    },
    {
        "slug": "plouer-sur-rance",
        "name": "Plouër-sur-Rance",
        "zone": "dinard",
        "dept": "Ille-et-Vilaine (35)",
        "dist": "34 km"
    },
    {
        "slug": "pleudihen-sur-rance",
        "name": "Pleudihen-sur-Rance",
        "zone": "dinard",
        "dept": "Ille-et-Vilaine (35)",
        "dist": "35 km"
    },
    {
        "slug": "saint-samson-sur-rance",
        "name": "Saint-Samson-sur-Rance",
        "zone": "dinard",
        "dept": "Ille-et-Vilaine (35)",
        "dist": "36 km"
    },
    {
        "slug": "la-vicomte-sur-rance",
        "name": "La Vicomté-sur-Rance",
        "zone": "dinard",
        "dept": "Ille-et-Vilaine (35)",
        "dist": "37 km"
    },
    {
        "slug": "dinan",
        "local": "À Dinan, les maisons à colombages de la rue du Jerzual, les gîtes de la cité médiévale et les appartements des quais de la Rance offrent aux punaises de lit mille cachettes : poutres, lambris, vieux planchers. Le tourisme soutenu de la cité augmente encore les introductions. Notre technicien connaît ce bâti ancien et adapte le traitement, vapeur ou chimique, pour protéger les matériaux tout en éradiquant l'infestation jusqu'au dernier œuf.",
        "name": "Dinan",
        "zone": "dinan",
        "dept": "Côtes-d'Armor (22)",
        "dist": "24 km"
    },
    {
        "slug": "lanvallay",
        "name": "Lanvallay",
        "zone": "dinan",
        "dept": "Côtes-d'Armor (22)",
        "dist": "25 km"
    },
    {
        "slug": "lehon",
        "name": "Léhon",
        "zone": "dinan",
        "dept": "Côtes-d'Armor (22)",
        "dist": "26 km"
    },
    {
        "slug": "taden",
        "name": "Taden",
        "zone": "dinan",
        "dept": "Côtes-d'Armor (22)",
        "dist": "27 km"
    },
    {
        "slug": "quevert",
        "name": "Quévert",
        "zone": "dinan",
        "dept": "Côtes-d'Armor (22)",
        "dist": "28 km"
    },
    {
        "slug": "aucaleuc",
        "name": "Aucaleuc",
        "zone": "dinan",
        "dept": "Côtes-d'Armor (22)",
        "dist": "29 km"
    },
    {
        "slug": "trelivan",
        "name": "Trélivan",
        "zone": "dinan",
        "dept": "Côtes-d'Armor (22)",
        "dist": "30 km"
    },
    {
        "slug": "bobital",
        "name": "Bobital",
        "zone": "dinan",
        "dept": "Côtes-d'Armor (22)",
        "dist": "31 km"
    },
    {
        "slug": "brusvily",
        "name": "Brusvily",
        "zone": "dinan",
        "dept": "Côtes-d'Armor (22)",
        "dist": "32 km"
    },
    {
        "slug": "le-hingle",
        "name": "Le Hinglé",
        "zone": "dinan",
        "dept": "Côtes-d'Armor (22)",
        "dist": "33 km"
    },
    {
        "slug": "trevron",
        "name": "Trévron",
        "zone": "dinan",
        "dept": "Côtes-d'Armor (22)",
        "dist": "34 km"
    },
    {
        "slug": "saint-carne",
        "name": "Saint-Carné",
        "zone": "dinan",
        "dept": "Côtes-d'Armor (22)",
        "dist": "35 km"
    },
    {
        "slug": "calorguen",
        "name": "Calorguen",
        "zone": "dinan",
        "dept": "Côtes-d'Armor (22)",
        "dist": "36 km"
    },
    {
        "slug": "saint-helen",
        "name": "Saint-Hélen",
        "zone": "dinan",
        "dept": "Côtes-d'Armor (22)",
        "dist": "37 km"
    },
    {
        "slug": "evran",
        "name": "Évran",
        "zone": "dinan",
        "dept": "Côtes-d'Armor (22)",
        "dist": "24 km"
    },
    {
        "slug": "saint-judoce",
        "name": "Saint-Judoce",
        "zone": "dinan",
        "dept": "Côtes-d'Armor (22)",
        "dist": "25 km"
    },
    {
        "slug": "saint-andre-des-eaux",
        "name": "Saint-André-des-Eaux",
        "zone": "dinan",
        "dept": "Côtes-d'Armor (22)",
        "dist": "26 km"
    },
    {
        "slug": "trefumel",
        "name": "Tréfumel",
        "zone": "dinan",
        "dept": "Côtes-d'Armor (22)",
        "dist": "27 km"
    },
    {
        "slug": "le-quiou",
        "name": "Le Quiou",
        "zone": "dinan",
        "dept": "Côtes-d'Armor (22)",
        "dist": "28 km"
    },
    {
        "slug": "treverien",
        "name": "Tréverien",
        "zone": "dinan",
        "dept": "Côtes-d'Armor (22)",
        "dist": "29 km"
    },
    {
        "slug": "pleugueneuc",
        "local": "À Pleugueneuc, entre le bourg rural, le château de la Bourbansais et les gîtes de la campagne environnante, les infestations de punaises de lit touchent aussi bien les maisons anciennes que les hébergements touristiques. Basés au Mont-Dol, à quelques minutes, nous intervenons chez vous très rapidement, avec un traitement professionnel et un rapport écrit pour les hébergements qui en ont besoin.",
        "name": "Pleugueneuc",
        "zone": "dinan",
        "dept": "Côtes-d'Armor (22)",
        "dist": "30 km"
    },
    {
        "slug": "saint-pierre-de-plesguen",
        "name": "Saint-Pierre-de-Plesguen",
        "zone": "dinan",
        "dept": "Côtes-d'Armor (22)",
        "dist": "31 km"
    },
    {
        "slug": "saint-jacut-de-la-mer",
        "name": "Saint-Jacut-de-la-Mer",
        "zone": "emeraude",
        "dept": "Côtes-d'Armor (22)",
        "dist": "38 km"
    },
    {
        "slug": "crehen",
        "name": "Créhen",
        "zone": "emeraude",
        "dept": "Côtes-d'Armor (22)",
        "dist": "39 km"
    },
    {
        "slug": "tregon",
        "name": "Trégon",
        "zone": "emeraude",
        "dept": "Côtes-d'Armor (22)",
        "dist": "40 km"
    },
    {
        "slug": "plancoet",
        "name": "Plancoët",
        "zone": "emeraude",
        "dept": "Côtes-d'Armor (22)",
        "dist": "41 km"
    },
    {
        "slug": "corseul",
        "name": "Corseul",
        "zone": "emeraude",
        "dept": "Côtes-d'Armor (22)",
        "dist": "42 km"
    },
    {
        "slug": "pluduno",
        "name": "Pluduno",
        "zone": "emeraude",
        "dept": "Côtes-d'Armor (22)",
        "dist": "43 km"
    },
    {
        "slug": "saint-lormel",
        "name": "Saint-Lormel",
        "zone": "emeraude",
        "dept": "Côtes-d'Armor (22)",
        "dist": "44 km"
    },
    {
        "slug": "saint-cast-le-guildo",
        "name": "Saint-Cast-le-Guildo",
        "zone": "emeraude",
        "dept": "Côtes-d'Armor (22)",
        "dist": "45 km"
    },
    {
        "slug": "matignon",
        "name": "Matignon",
        "zone": "emeraude",
        "dept": "Côtes-d'Armor (22)",
        "dist": "46 km"
    },
    {
        "slug": "saint-potan",
        "name": "Saint-Pôtan",
        "zone": "emeraude",
        "dept": "Côtes-d'Armor (22)",
        "dist": "47 km"
    },
    {
        "slug": "pleboulle",
        "name": "Pléboulle",
        "zone": "emeraude",
        "dept": "Côtes-d'Armor (22)",
        "dist": "48 km"
    },
    {
        "slug": "frehel",
        "name": "Fréhel",
        "zone": "emeraude",
        "dept": "Côtes-d'Armor (22)",
        "dist": "49 km"
    },
    {
        "slug": "plevenon",
        "name": "Plévenon",
        "zone": "emeraude",
        "dept": "Côtes-d'Armor (22)",
        "dist": "50 km"
    },
    {
        "slug": "plurien",
        "name": "Plurien",
        "zone": "emeraude",
        "dept": "Côtes-d'Armor (22)",
        "dist": "51 km"
    },
    {
        "slug": "erquy",
        "name": "Erquy",
        "zone": "emeraude",
        "dept": "Côtes-d'Armor (22)",
        "dist": "38 km"
    },
    {
        "slug": "tinteniac",
        "name": "Tinténiac",
        "zone": "rennes",
        "dept": "Ille-et-Vilaine (35)",
        "dist": "28 km"
    },
    {
        "slug": "quebriac",
        "name": "Québriac",
        "zone": "rennes",
        "dept": "Ille-et-Vilaine (35)",
        "dist": "29 km"
    },
    {
        "slug": "saint-domineuc",
        "name": "Saint-Domineuc",
        "zone": "rennes",
        "dept": "Ille-et-Vilaine (35)",
        "dist": "30 km"
    },
    {
        "slug": "trimer",
        "name": "Trimer",
        "zone": "rennes",
        "dept": "Ille-et-Vilaine (35)",
        "dist": "31 km"
    },
    {
        "slug": "la-chapelle-aux-filtzmeens",
        "name": "La Chapelle-aux-Filtzméens",
        "zone": "rennes",
        "dept": "Ille-et-Vilaine (35)",
        "dist": "32 km"
    },
    {
        "slug": "hede-bazouges",
        "name": "Hédé-Bazouges",
        "zone": "rennes",
        "dept": "Ille-et-Vilaine (35)",
        "dist": "33 km"
    },
    {
        "slug": "dinge",
        "name": "Dingé",
        "zone": "rennes",
        "dept": "Ille-et-Vilaine (35)",
        "dist": "34 km"
    },
    {
        "slug": "guipel",
        "name": "Guipel",
        "zone": "rennes",
        "dept": "Ille-et-Vilaine (35)",
        "dist": "35 km"
    },
    {
        "slug": "montreuil-sur-ille",
        "name": "Montreuil-sur-Ille",
        "zone": "rennes",
        "dept": "Ille-et-Vilaine (35)",
        "dist": "36 km"
    },
    {
        "slug": "saint-medard-sur-ille",
        "name": "Saint-Médard-sur-Ille",
        "zone": "rennes",
        "dept": "Ille-et-Vilaine (35)",
        "dist": "37 km"
    },
    {
        "slug": "melesse",
        "name": "Melesse",
        "zone": "rennes",
        "dept": "Ille-et-Vilaine (35)",
        "dist": "38 km"
    },
    {
        "slug": "la-meziere",
        "name": "La Mézière",
        "zone": "rennes",
        "dept": "Ille-et-Vilaine (35)",
        "dist": "39 km"
    },
    {
        "slug": "geveze",
        "name": "Gévezé",
        "zone": "rennes",
        "dept": "Ille-et-Vilaine (35)",
        "dist": "40 km"
    },
    {
        "slug": "vignoc",
        "name": "Vignoc",
        "zone": "rennes",
        "dept": "Ille-et-Vilaine (35)",
        "dist": "41 km"
    },
    {
        "slug": "montgermont",
        "name": "Montgermont",
        "zone": "rennes",
        "dept": "Ille-et-Vilaine (35)",
        "dist": "28 km"
    },
    {
        "slug": "betton",
        "local": "À Betton, commune résidentielle au nord de Rennes sur l'axe de Saint-Malo, les pavillons familiaux dominent : les punaises de lit y arrivent le plus souvent via un voyage, un achat de meuble d'occasion ou une location de vacances. Nous réalisons la recherche dans toutes les chambres, traitons avec la méthode la plus adaptée et restons joignables 7j/7 en cas de doute après l'intervention.",
        "name": "Betton",
        "zone": "rennes",
        "dept": "Ille-et-Vilaine (35)",
        "dist": "29 km"
    },
    {
        "slug": "saint-gregoire",
        "name": "Saint-Grégoire",
        "zone": "rennes",
        "dept": "Ille-et-Vilaine (35)",
        "dist": "30 km"
    },
    {
        "slug": "pace",
        "name": "Pacé",
        "zone": "rennes",
        "dept": "Ille-et-Vilaine (35)",
        "dist": "31 km"
    },
    {
        "slug": "rennes",
        "local": "À Rennes, les colocations étudiantes, les résidences de Villejean ou de Beaulieu et les immeubles du centre historique voient passer des dizaines d'occupants par an : un terrain idéal pour les punaises de lit. Nous traitons aussi bien le studio d'un étudiant que l'appartement haussmannien près de la place des Lices ou la maison de Thabor. Chaque intervention est précédée d'une recherche complète, car dans un immeuble collectif rennais, les punaises migrent souvent d'un logement à l'autre par les gaines et les plinthes.",
        "name": "Rennes",
        "zone": "rennes",
        "dept": "Ille-et-Vilaine (35)",
        "dist": "32 km"
    },
    {
        "slug": "cesson-sevigne",
        "local": "À Cesson-Sévigné, entre les résidences familiales, les hôtels d'affaires près d'Atalante et les logements étudiants, les profils d'infestation varient mais la réponse reste la même : une recherche méthodique puis un traitement professionnel. Nous couvrons Cesson-Sévigné et l'est rennais avec une intervention sous 2h et des tarifs affichés, sans surprise.",
        "name": "Cesson-Sévigné",
        "zone": "rennes",
        "dept": "Ille-et-Vilaine (35)",
        "dist": "33 km"
    },
    {
        "slug": "thorigne-fouillard",
        "name": "Thorigné-Fouillard",
        "zone": "rennes",
        "dept": "Ille-et-Vilaine (35)",
        "dist": "34 km"
    },
    {
        "slug": "acigne",
        "name": "Acigné",
        "zone": "rennes",
        "dept": "Ille-et-Vilaine (35)",
        "dist": "35 km"
    },
    {
        "slug": "chantepie",
        "name": "Chantepie",
        "zone": "rennes",
        "dept": "Ille-et-Vilaine (35)",
        "dist": "36 km"
    },
    {
        "slug": "noyal-chatillon-sur-seiche",
        "name": "Noyal-Châtillon-sur-Seiche",
        "zone": "rennes",
        "dept": "Ille-et-Vilaine (35)",
        "dist": "37 km"
    },
    {
        "slug": "saint-jacques-de-la-lande",
        "local": "À Saint-Jacques-de-la-Lande, première couronne de Rennes, les résidences récentes côtoient un habitat pavillonnaire plus ancien : les punaises de lit ne choisissent pas leur standing, elles suivent les déplacements. Nous intervenons sur toute la commune, de la ZA de la lande aux quartiers résidentiels, avec un traitement garanti et un suivi jusqu'à l'éradication complète.",
        "name": "Saint-Jacques-de-la-Lande",
        "zone": "rennes",
        "dept": "Ille-et-Vilaine (35)",
        "dist": "38 km"
    },
    {
        "slug": "bruz",
        "local": "À Bruz, le campus de Beaulieu tout proche et les résidences étudiantes génèrent une forte mobilité locative, première porte d'entrée des punaises de lit dans les logements. Nous traitons studios, colocations et maisons familiales de Bruz avec des protocoles adaptés à chaque configuration, et nous expliquons aux occupants les bons réflexes pour éviter une réinfestation après notre passage.",
        "name": "Bruz",
        "zone": "rennes",
        "dept": "Ille-et-Vilaine (35)",
        "dist": "39 km"
    },
    {
        "slug": "le-rheu",
        "name": "Le Rheu",
        "zone": "rennes",
        "dept": "Ille-et-Vilaine (35)",
        "dist": "40 km"
    },
    {
        "slug": "vezin-le-coquet",
        "name": "Vezin-le-Coquet",
        "zone": "rennes",
        "dept": "Ille-et-Vilaine (35)",
        "dist": "41 km"
    },
    {
        "slug": "mordelles",
        "name": "Mordelles",
        "zone": "rennes",
        "dept": "Ille-et-Vilaine (35)",
        "dist": "28 km"
    },
    {
        "slug": "fougeres",
        "local": "À Fougères, les logements anciens qui entourent le château médiéval et les immeubles du centre-ville concentrent la majorité des cas que nous traitons. Les punaises de lit s'y propagent facilement entre étages et appartements mitoyens. Nous intervenons sur Fougères et ses quartiers avec un protocole complet : recherche minutieuse, traitement professionnel et conseils pour éviter la réinfestation par les logements voisins.",
        "name": "Fougères",
        "zone": "rennes",
        "dept": "Ille-et-Vilaine (35)",
        "dist": "29 km"
    },
    {
        "slug": "vitre",
        "local": "À Vitré, la croissance résidentielle autour de la cité de caractère et du château attire de nouveaux habitants, et avec eux des déménagements fréquents, première cause d'arrivée des punaises de lit via les meubles et cartons. Nous intervenons dans les pavillons récents comme dans les immeubles du centre historique de Vitré, avec un traitement garanti et un repassage gratuit sous 30 jours si nécessaire.",
        "name": "Vitré",
        "zone": "rennes",
        "dept": "Ille-et-Vilaine (35)",
        "dist": "30 km"
    },
    {
        "slug": "plelan-le-petit",
        "name": "Plélan-le-Petit",
        "zone": "lamballe",
        "dept": "Côtes-d'Armor (22)",
        "dist": "42 km"
    },
    {
        "slug": "vilde-guingalan",
        "name": "Vildé-Guingalan",
        "zone": "lamballe",
        "dept": "Côtes-d'Armor (22)",
        "dist": "43 km"
    },
    {
        "slug": "saint-maudez",
        "name": "Saint-Maudez",
        "zone": "lamballe",
        "dept": "Côtes-d'Armor (22)",
        "dist": "44 km"
    },
    {
        "slug": "bourseul",
        "name": "Bourseul",
        "zone": "lamballe",
        "dept": "Côtes-d'Armor (22)",
        "dist": "45 km"
    },
    {
        "slug": "plorec-sur-arguenon",
        "name": "Plorec-sur-Arguenon",
        "zone": "lamballe",
        "dept": "Côtes-d'Armor (22)",
        "dist": "46 km"
    },
    {
        "slug": "pledeliac",
        "name": "Plédéliac",
        "zone": "lamballe",
        "dept": "Côtes-d'Armor (22)",
        "dist": "47 km"
    },
    {
        "slug": "jugon-les-lacs",
        "name": "Jugon-les-Lacs",
        "zone": "lamballe",
        "dept": "Côtes-d'Armor (22)",
        "dist": "48 km"
    },
    {
        "slug": "plenee-jugon",
        "name": "Plénée-Jugon",
        "zone": "lamballe",
        "dept": "Côtes-d'Armor (22)",
        "dist": "49 km"
    },
    {
        "slug": "tramain",
        "name": "Tramain",
        "zone": "lamballe",
        "dept": "Côtes-d'Armor (22)",
        "dist": "50 km"
    },
    {
        "slug": "sevignac",
        "name": "Sévignac",
        "zone": "lamballe",
        "dept": "Côtes-d'Armor (22)",
        "dist": "51 km"
    },
    {
        "slug": "plestan",
        "name": "Plestan",
        "zone": "lamballe",
        "dept": "Côtes-d'Armor (22)",
        "dist": "52 km"
    },
    {
        "slug": "noyal",
        "name": "Noyal",
        "zone": "lamballe",
        "dept": "Côtes-d'Armor (22)",
        "dist": "53 km"
    },
    {
        "slug": "lamballe-armor",
        "name": "Lamballe-Armor",
        "zone": "lamballe",
        "dept": "Côtes-d'Armor (22)",
        "dist": "54 km"
    },
    {
        "slug": "landehen",
        "name": "Landéhen",
        "zone": "lamballe",
        "dept": "Côtes-d'Armor (22)",
        "dist": "55 km"
    },
    {
        "slug": "meslin",
        "name": "Meslin",
        "zone": "lamballe",
        "dept": "Côtes-d'Armor (22)",
        "dist": "42 km"
    },
    {
        "slug": "andel",
        "name": "Andel",
        "zone": "lamballe",
        "dept": "Côtes-d'Armor (22)",
        "dist": "43 km"
    },
    {
        "slug": "coetmieux",
        "name": "Coëtmieux",
        "zone": "lamballe",
        "dept": "Côtes-d'Armor (22)",
        "dist": "44 km"
    },
    {
        "slug": "pommeret",
        "name": "Pommeret",
        "zone": "lamballe",
        "dept": "Côtes-d'Armor (22)",
        "dist": "45 km"
    },
    {
        "slug": "yffiniac",
        "name": "Yffiniac",
        "zone": "lamballe",
        "dept": "Côtes-d'Armor (22)",
        "dist": "46 km"
    },
    {
        "slug": "hillion",
        "name": "Hillion",
        "zone": "lamballe",
        "dept": "Côtes-d'Armor (22)",
        "dist": "47 km"
    },
    {
        "slug": "langueux",
        "name": "Langueux",
        "zone": "lamballe",
        "dept": "Côtes-d'Armor (22)",
        "dist": "48 km"
    },
    {
        "slug": "tregueux",
        "name": "Trégueux",
        "zone": "lamballe",
        "dept": "Côtes-d'Armor (22)",
        "dist": "49 km"
    },
    {
        "slug": "ploufragan",
        "name": "Ploufragan",
        "zone": "lamballe",
        "dept": "Côtes-d'Armor (22)",
        "dist": "50 km"
    },
    {
        "slug": "saint-brieuc",
        "name": "Saint-Brieuc",
        "zone": "lamballe",
        "dept": "Côtes-d'Armor (22)",
        "dist": "51 km"
    },
    {
        "slug": "pontorson",
        "local": "À Pontorson, porte d'entrée du Mont-Saint-Michel, des millions de visiteurs transitent chaque année : hôtels, campings et locations meublées y connaissent une rotation exceptionnelle, et avec elle un risque élevé d'introduction de punaises de lit. Nous intervenons en urgence sur Pontorson et la baie, 7j/7, avec des protocoles adaptés aux établissements qui ne peuvent pas se permettre de fermer une chambre plusieurs jours.",
        "name": "Pontorson",
        "zone": "dol",
        "dept": "Manche (50)",
        "dist": "20 km"
    },
    {
        "slug": "ducey",
        "name": "Ducey",
        "aka": "Ducey-Les Chéris, 50220",
        "zone": "dol",
        "dept": "Manche (50)",
        "dist": "25 km"
    },
    {
        "slug": "avranches",
        "name": "Avranches",
        "zone": "dol",
        "dept": "Manche (50)",
        "dist": "30 km"
    },
    {
        "slug": "granville",
        "name": "Granville",
        "zone": "dol",
        "dept": "Manche (50)",
        "dist": "45 km"
    }
];
